
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiLock, FiArrowRight } from 'react-icons/fi';
import './LoginPage.css';
import securityIcon from '../assets/security.svg';


const LoginPage = ({ onLogin }) => {
    const [password, setPassword] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        onLogin(password);
    };

    return (
        <motion.div 
            className="login-container"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
        >
            <motion.div 
                className="login-box"
                initial={{ y: -50, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.2, type: 'spring', stiffness: 120 }}
            >
                <img src={securityIcon} alt="Security" className="security-icon" />
                <h2>Access Restricted</h2>
                <p>This document is confidential. Please enter the password to proceed.</p>
                <form onSubmit={handleSubmit}>
                    <div className="input-wrapper">
                        <FiLock className="input-icon" />
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Password"
                            autoFocus
                        />
                    </div>
                    <button type="submit">
                        Unlock <FiArrowRight />
                    </button>
                </form>
            </motion.div>
        </motion.div>
    );
};

export default LoginPage;
